import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { peopleAddress } from 'global/Models/addressModel';

type initialStateType = {
  addressList: peopleAddress[] | undefined;
};

const initialState: initialStateType = {
  addressList: undefined,
};

export const addressSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    setAllAddress: (state, action: PayloadAction<peopleAddress[]>) => {
      state.addressList = action.payload;
    },
  },
});

export const { setAllAddress } = addressSlice.actions;

export default addressSlice.reducer;
